import type { PlanningPhase } from '@wtta/scoring'

interface PlanningSectionProps {
  planning: PlanningPhase[]
}

export function PlanningSection({ planning }: PlanningSectionProps) {
  const totalTasks = planning.reduce((sum, phase) => sum + phase.tasks.length, 0)

  if (totalTasks === 0) {
    return null
  }

  return (
    <section className="report-section" data-testid="planning-section">
      <h2 className="report-section__title">90-dagen planning</h2>
      <p className="report-section__lead">
        De aanbevelingen zijn verdeeld over drie fases. Deze planning is een
        suggestie. Pas hem aan op jouw eigen capaciteit en bestaande projecten.
      </p>

      <div className="planning-phases">
        {planning.map((phase) => (
          <div
            key={phase.id}
            className="planning-phase"
            data-testid={`phase-${phase.id}`}
          >
            <header className="planning-phase__header">
              <h3 className="planning-phase__title">{phase.title}</h3>
              <span className="planning-phase__window">
                Dag {phase.startDayOffset} – {phase.endDayOffset}
              </span>
            </header>
            <p className="planning-phase__description">{phase.description}</p>
            {phase.tasks.length === 0 ? (
              <p className="planning-phase__empty">Geen acties in deze fase op basis van jouw profiel.</p>
            ) : (
              <ol className="planning-phase__tasks">
                {phase.tasks.map((task) => (
                  <li
                    key={task.id}
                    className="planning-task"
                    data-testid={`task-${task.id}`}
                  >
                    <span className="planning-task__day">
                      Dag {task.startDayOffset}–{task.startDayOffset + task.durationDays}
                    </span>
                    <span className="planning-task__title">{task.title}</span>
                  </li>
                ))}
              </ol>
            )}
          </div>
        ))}
      </div>
    </section>
  )
}
